export const FETCH_NOTIFICATION_LISTING = "FETCH_NOTIFICATION_LISTING"